export enum UserRoles {
  ADMIN = 'Admin',
  COMMERCIAL = 'Comercial',
  FINANCE = 'Finanzas',
  LOGISTICS = 'Logistica',
  SELLER = 'Seller',
  DRIVER = 'Chofer',
}
